import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public')({
  // Removed server-side loader for static build
  // Auth checks will be handled client-side
})
